import 'css-chunksrc/client/scenes/workloads/wbs/task/taskStatus/styles.scss';export default {
  "taskStatus": "_taskStatus_vzelv_1",
  "name": "_name_vzelv_7"
};